module.exports = __webpack_public_path__ + "assets/images/project/head/Naomi_Osaka.jpg?v=67aaf336";